import { InjectionToken } from '@angular/core';

export const FIREBASE_AUTH_BASE_URLS = new InjectionToken<string[]>('FIREBASE_AUTH_BASE_URLS');
